import { Button, ButtonProps, Tooltip } from 'antd'
import { ReactNode } from 'react'

interface Props extends ButtonProps {
  tooltip: ReactNode
  children: ReactNode
}

export const ListActionButton = ({ tooltip, children, ...buttonProps }: Props) => (
  <Tooltip title={tooltip}>
    <Button {...buttonProps}>
      {children}
    </Button>
  </Tooltip>
)
